import * as types from "../types/localeTypes";
import { initialLocaleState } from "../initialState";

export const locales = (state = initialLocaleState, action) => {
  switch (action.type) {
    case types.ENG:
      return { local: action.en };
    case types.PTR:
      return { local: action.pt };
    default:
      return state;
  }
};
